export const PRIVILEGES = {
  SHOW_BANNER_NOTIFICATION: ["view_notification"],
  SHOW_HISTORY_PAGE: ["view_history_page"],
  SHOW_SUBSCRIPTION_PAGE: ["view_subscription"],
  SHOW_PAYMENT_HISTORY: ["payment_history"],
  MANAGE_SUBSCRIPTION: ["list_subscription"],
  SHOW_USER_MANAGEMENT: ["view_user_management"],
  EDIT_USER: ["edit_client_user"],
  INVITE_USER: ["add_client_user"],
  ENABLE_REVOKE_ACCESS: ["edit_revoke_access"],
  ENABLE_SFTP_ACCESS: ["add_ftp"],
  ENABLE_PENDING_INVITATION: ["list_applicant"],
  ENABLE_INVITATION_APPROVAL: ["edit_applicant"],
  ENABLE_RESEND_INVITATION: ["add_client_user"],
  MANAGE_SUBSCRIPTION_UI: ["manage_subscription"],
  HIDE_MANAGE_SUBSCRIPTION_UI: ["hide_manage_subscription"],

  SHOW_CAMPAIGN_MANAGEMENT: ["view_campaign_management"],

  SHOW_EMAIL_TEMPLATE_MANAGEMENT: ["view_email_template_management"],
  VIEW_EMAIL_TEMPLATE: ["view_template"],
  CREATE_EMAIL_TEMPLATE: ["add_template"],
  EDIT_EMAIL_TEMPLATE: ["edit_template"],
  DELETE_EMAIL_TEMPLATE: ["delete_template"],

  SHOW_EMAIL_CAMPAIGN_MANAGEMENT: ["view_email_campaign_management"],
  VIEW_EMAIL_CAMPAIGN: ["view_campaign"],
  CREATE_EMAIL_CAMPAIGN: ["add_campaign"],
  EDIT_EMAIL_CAMPAIGN: ["edit_campaign"],
  DELETE_EMAIL_CAMPAIGN: ["delete_campaign"],
  VIEW_EMAIL_CAMPAIGN_REPORT: ["view_campaignsummary"],

  SHOW_SMS_CAMPAIGN_MANAGEMENT: ["view_sms_campaign_management"],
  VIEW_SMS_CAMPAIGN: ["view_sms_campaign"],
  CREATE_SMS_CAMPAIGN: ["add_sms_campaign"],
  EDIT_SMS_CAMPAIGN: ["edit_sms_campaign"],
  DELETE_SMS_CAMPAIGN: ["delete_sms_campaign"],
  VIEW_SMS_CAMPAIGN_REPORT: ["view_campaignsummary"],

  SHOW_CONSUMER_LIST_MANAGEMENT: ["view_consumer_list_management"],
  EDIT_CONSUMER_LIST: ["edit_customer"],
  DELETE_CONSUMER_LIST: ["delete_customer"],

  DASHBOARD_PAGE_ACCESS: ["list_dashboard_data"],
  DASHBOARD_PDF_ACCESS: ["dashboard_export"],
  FHS_PDF_ACCESS: ["fhs_export"],
  EXPORT_DATA_ACCESS: ["export_data"],
  SHOW_EWI_STRATEGIES: ["list_ewi"],
  SHOW_OLD_EWI_CHATBOT: ["view_old_ewi_chatbot"],

  SHOW_COHORT_MANAGEMENT: ["view_cohort"],
  CREATE_COHORT: ["add_cohort"],
  EDIT_COHORT: ["edit_cohort"],
  DELETE_COHORT: ["delete_cohort"],

  DRILLDOWN_ACCESS: ["list_drilldown_data"],
  VIEW_DETAILS_ACCESS: ["view_details_data"],

  VIEW_FILTERS: ["view_save_filter"],
  SAVE_FILTER: ["add_save_filter"],
  EDIT_FILTER: ["edit_save_filter"],
  DELETE_FILTER: ["delete_save_filter"],

  VIEW_COHORT: ["view_cohort"],
  CHATBOT: ["chatbot"],

  HIDE_HISTORY_PAGE: ["hide_history"],
  HIDE_CAMPAIGN_MANAGEMENT: ["hide_campaign"],
  HIDE_USERS_MANAGEMENT: ["hide_user_management"],
  HIDE_SUPPORT: ["hide_support"],

  TEST: ["12345"],

  SHOW_SUPPORT: ["show_support"],
  SHOW_SUBSCRIPTION_MENU: ["show_subscription_menu"],
};
